import axios from "axios";
import auth from "@/gotrue.js";
import store from "@/store";
import NProgress from "nprogress";

axios.interceptors.request.use(
  config => {
    NProgress.start();
    config.headers["Accept"] = "application/json";
    config.headers["Content-Type"] = "application/json";
    const user = auth.currentUser();
    if (user && config.url.includes("netlify")) {
      const jwt = user.jwt();
      jwt
        .then(response => {
          config.headers["Authorization"] = "Bearer " + response;
          return config;
        })
        .catch(error => {
          console.log("Error fetching JWT token", error);
          return config;
        });
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    NProgress.done();
    return response;
  },
  function(error) {
    const originalRequest = error.config;
    NProgress.done();
    if (error.response.status != 401) {
      return Promise.reject(error);
    }
    const user = auth.currentUser();
    if (!user) {
      store.dispatch("auth/attemptLogout")
    }
    else if (user && originalRequest.url.includes("netlify")) {
      const jwt = user.jwt();
      jwt
        .then(response => {

          axios.defaults.headers.common["Authorization"] = "Bearer " + response;
          return axios(originalRequest);
        })
        .catch(error => {

          console.log("Error fetching JWT token", error);
          return Promise.reject(error);
        });
    }
    return Promise.reject(error);
  }
);

export default axios;
